export class RegistrationInputField {
    fieldName;
    value;
	defaultValue;
	/**
	 * Array of error strings
	 */
    errors;
	/**
	 * Array of functions that are used to validate field
	 */
	validationFunctions;
	defaultValidationFunctions;
    
	constructor(fieldName, value, validationFunctions = []) {
		this.fieldName = fieldName;
		this.value = value;
		this.defaultValue = value;
		this.validationFunctions = validationFunctions;
		this.defaultValidationFunctions = validationFunctions;
		this.errors = [];
	}

	reset = () => {
		this.value = this.defaultValue;
		this.errors = [];
	}

	/**
	 * Call every validation that assigning to this field and returns TRUE of FALSE
	 * @returns {*} TRUE if valid and FALSE if not valid
	 */
	isValid = () => {
		return this.errors.length === 0;
	}

	/**
	 * Call every validation that assigning to this field and returns array of errors
	 * @returns {*} Array of errors. If no errors then empty Array
	 */
	validate = () => {
		this.errors = this.validationFunctions.map(x => x(this.value)).flat();
	}

	/**
	 * Find the first error if exists.
	 * Useful for MUI AlertBoxes where only one row can be properly displayed.
	 * @returns {} String error
	 */
	topError = () => {
		return this.errors.length > 0
			? this.errors[0]
			: "";
	}

	/**
	 * Forget previos validations and set new validations
	 * @param newValidations Array of new validations
	 */
	setValidations = (newValidations) => {
		this.validationFunctions = newValidations;
		return this;
	}

	/**
	 * Add a new validation
	 * @param newValidation New validation function
	 */
	withAdditionalValidation = (newValidation) => {
		this.validationFunctions = [...this.defaultValidationFunctions];
		this.validationFunctions.push(newValidation);
		return this;
	}
}